module.exports = __webpack_public_path__ + "static/media/boho-brenda.e9bc2385.png";